import { defineStore } from 'pinia';
import { User } from 'firebase/auth';
import { ProfileApi } from 'boot/api';
import { error } from 'src/error/error';
import { Role, getRoleLabel } from 'src/models/enum/Role';
type CurrentUser = {
  name: string;
  email: string;
  clientName: string;
  role: Role;
  roleLabel: string;
  isAdmin: boolean;
} | null;
export const useCurrentUserStore = defineStore('currentUser', {
  state: () => ({
    name: '',
    email: '',
    clientName: '',
    role: 'none' as Role,
    roleLabel: 'なし',
    isAdmin: false,
    isLogined: false,
  }),

  getters: {
    currentUser: (state): CurrentUser => {
      if (state.isLogined) {
        return {
          name: state.name,
          email: state.email,
          clientName: state.clientName,
          role: state.role,
          roleLabel: state.roleLabel,
          isAdmin: state.isAdmin,
        };
      }
      return null;
    },
  },

  actions: {
    async setCurrentUser(user: User) {
      this.isLogined = true;
      this.email = user.email || '';
      try {
        const profile = await ProfileApi.getProfile();
        this.name = profile.name;
        this.role = profile.role;
        this.roleLabel = getRoleLabel(profile.role);
        this.isAdmin = profile.role == 'general_manager';
        this.clientName = profile.client_name;
      } catch (e) {
        error(e);
      }
    },
    initCurrentUser() {
      this.name = '';
      this.email = '';
      this.clientName = '';
      this.isLogined = false;
      this.isAdmin = false;
      this.role = 'none' as Role;
      this.roleLabel = 'なし';
    },
  },
});
